import { Component } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { Ng2Cable, Broadcaster } from 'ng2-cable';
import { MessengerModalComponent } from '../messenger_modal/messenger_modal';
import { ConversationsService } from '../../providers';

@Component({
  selector: 'assistant',
  styleUrls: ['./assistant.scss'],
  templateUrl: './assistant.pug'
})

export class AssistantComponent {
  assistantChat = JSON.parse(window.localStorage.getItem('assistantChat'));
  chatIsOpen: boolean;
  newMessagesCount: number = 0;
  user = JSON.parse(window.localStorage.getItem('currentUser'));
  modalRef: any;

  constructor(public toastr: ToastsManager,
              private modalService: NgbModal,
              private ng2cable: Ng2Cable,
              private broadcaster: Broadcaster,
              private conversationService: ConversationsService) {}

  public ngOnInit() {
    if (this.assistantChat) {
      this.subscribeToAssistantChannel(this.assistantChat.id);
    }
  }

  openAssistant() {
    this.chatIsOpen = true;
    this.newMessagesCount = 0;
    if (!this.assistantChat) {
      this.startChat();
    }
    this.modalRef = this.modalService.open(MessengerModalComponent, { windowClass: 'messenger-modal', backdrop: false });
    this.modalRef.result.then((data) => {
      this.chatIsOpen = false;
    }, () => { this.chatIsOpen = false; });
  }

  closeAssistant() {
    this.chatIsOpen = false;
    this.modalRef.close();
  }

  private startChat() {
    let params = { conversation: {} };
    if (this.user) {
      params['conversation']['sender_id'] = this.user.id;
    }
    this.conversationService.create(params).subscribe((data) => {
      this.assistantChat = { ...data, messages: [] };
      window.localStorage.setItem('assistantChat', JSON.stringify(this.assistantChat));
      this.subscribeToAssistantChannel(data['id']);
      this.conversationService.setConversation(this.assistantChat);
    }, (err) => {
      this.toastr.info('Sorry, but something wrong.');
    })
  }

  private subscribeToAssistantChannel(conversationId: number) {
    this.ng2cable.subscribe(`${API_URL}/cable`, 'MessagesChannel', { conversation: conversationId });

    this.broadcaster.on<string>('MessagesChannel').subscribe(
      data => { this.updateChat(data['message']); }
    );
  }

  private updateChat(message: Object) {
    this.conversationService.addMessage({ body: message['body'], own: false });
    if (!this.chatIsOpen) {
      this.newMessagesCount += 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/assistant/assistant.ts